import React from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";
import ImageText2 from "../../components/ImageText2";
import ImageText1 from "../../components/ImageText1";
import Footer from "../../components/Footer";
import backgroundImage from "../../assets/images/hrorganisatie/bg-hrorg.jpg";
import imageUrl1 from "../../assets/images/hrorganisatie/hrorg-section1.jpg";
import imageUrl2 from "../../assets/images/hrorganisatie/hrorg-section2.jpg";
import imageUrl3 from "../../assets/images/hrorganisatie/hrorg-section3.jpg";
import imageUrl4 from "../../assets/images/hrorganisatie/hrorg-section4.jpg";
import imageUrl5 from "../../assets/images/hrorganisatie/hrorg-section5.jpg";

function HROrganisatieadvies() {
  const welcomeHeading = <>HR en Organisatieadvies</>;

  const imageTextText = (
    <>
      DD Group biedt een breed palet aan HR en Organisatieadvies diensten.
      <br />
      <h2>HR Advies</h2>
      <h3>Quickscan </h3>
      Een quickscan wordt gehanteerd voor een analyse op bestaand HR-beleid en
      geeft zicht op te ontwikkelen of aan te passen HR-beleid. Middels een
      vlootschouw, competentie- en talentscan wordt een 0-meting gehouden om een
      passende aanpak richting management en teams te adviseren.
    </>
  );
  const imageTextText1 = (
    <>
      <h3>HR beleid </h3>
      Vanuit de strategie van de organisatie wordt de vertaalslag gemaakt naar
      wat dit betekent voor HR binnen de organisatie. Er wordt rekening gehouden
      met de omgeving waarin de organisatie zich bevindt, welke strategie het
      management van voor ogen heeft, welke doelstellingen men wil behalen en
      wat de cultuur van de organisatie is. Het nieuwe HR- beleid sluit hierbij
      aan, zodat het past binnen de (koers van de) organisatie. Ook het
      ontwikkelen van HR-beleid wat volgt uit nieuwe wetgeving of
      Cao-aanpassingen behoort tot het palet. Voorts kunnen wij HR-instrumenten
      en HR-beleid ontwikkelen als strategische personeelsplanning,
      beoordelingsbeleid, functiehuis en recruitmentbeleid. Wij ontwikkelen
      arbeidsvoorwaarden en salarisstructuren en begeleiden het harmoniseren van
      arbeidsvoorwaarden en conversies van alles op het gebied van HR. Centraal
      bij HR Advies in algemene zin staat het vertalen van de koers naar een
      pragmatisch bij de organisatie passend HR-beleid cq. HR-instrument.
    </>
  );
  const imageTextText2 = (
    <>
      <h3>Organisatieadvies en begeleiding van organisatieveranderingen.</h3>
      Denk hierbij aan organisatieontwerp, organisatieontwikkeling en het
      begeleiden van allerlei vormen van organisatieveranderingen als start ups,
      fusies, reorganisaties, het opzetten dan wel verder ontwikkelen en
      professionaliseren van de HR-functie en het herijken en herinrichten van
      HR- en bedrijfsprocessen volgens bijv. de Lean-principes. Er wordt hierbij
      onder meer rekening gehouden met het verloop van dit soort
      veranderprocessen en hoe je stakeholders hierin meeneemt, de
      veranderaanpak, cultuuraspecten, allerlei HR juridische zaken, overleg met
      eventuele medezeggenschap en/of vakbonden en implementatieplannen.
    </>
  );
  const imageTextText3 = (
    <>
      <h3>Sparringpartner en coach</h3>
      Wij zijn een deskundig en betrokken klankbord voor vraagstukken waar
      bestuurders, directeuren, leidinggevenden en ondernemers tegenaan lopen.
      In deze posities sta je er vaak alleen voor. “It’s lonely at the top”. Met
      onze ruime ervaring in diverse organisaties en branches en onze eigen
      ervaringen als bijvoorbeeld leidinggevende kunnen wij meedenken, een
      luisterend oor bieden en gevraagd of ongevraagd advies verstrekken. Wij
      zijn bekend met de (bestuurlijke) uitdagingen in grote en kleinere
      organisaties en we kunnen ons goed inleven in managementproblematieken.
      Wij denken mee over zakelijke kwesties en helpen reflecteren op
      werksituaties en/of persoonlijke dilemma’s hierin. Daarnaast coachen en
      begeleiden wij junior adviseurs.
    </>
  );
  const imageTextText4 = (
    <>
      Tevens beschikken wij over modules en instrumenten op het gebied van
      loopbaanbegeleiding, welke inzicht geven in wie je bent en je helpen
      helder te krijgen wat je kwaliteiten, interesses, drijfveren en behoeftes
      zijn. Wij kunnen ook teams begeleiden in hun ontwikkelingsproces om een
      succesvoller team te worden.
    </>
  );

  return (
    <div>
      <Helmet>
        <title>HR en Organisatieadvies</title>
        <meta
          name="description"
          content="DD-Group biedt gespecialiseerde wervings- en detacheringdiensten in verschillende sectoren, waaronder industrie, bouw en logistiek. Wij bieden nu ook 'DD-Group Klus & Tuin' voor particulieren, waarmee je vakbekwame professionals kunt vinden voor thuisprojecten tegen betaalbare tarieven."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <ImageText2
            imageUrl={imageUrl1}
            text={imageTextText}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          <ImageText1 imageUrl={imageUrl2} text={imageTextText1} />
          <ImageText2
            imageUrl={imageUrl3}
            text={imageTextText2}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          <ImageText1 imageUrl={imageUrl4} text={imageTextText3} />
          <ImageText2
            imageUrl={imageUrl5}
            text={imageTextText4}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          {/* <CardImage src={src} /> */}
          {/* <Contact /> */}
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default HROrganisatieadvies;
